@import '../../style/focus-outline.scss';
@import '../com-nav/com-nav-focus.scss';
@import '../../style/breakpoints.scss';

:host {
    --wcs-com-nav-category-label-mobile-font-weight: var(--wcs-semantic-font-weight-medium);
    --wcs-com-nav-category-label-mobile-color: var(--wcs-semantic-color-text-primary);

    --wcs-com-nav-category-label-font-size: var(--wcs-semantic-font-size-label-1);
    --wcs-com-nav-category-label-desktop-font-weight: var(--wcs-semantic-font-weight-roman);
    --wcs-com-nav-category-label-desktop-color: var(--wcs-semantic-color-text-primary);
    --wcs-com-nav-category-label-desktop-gap: var(--wcs-semantic-spacing-base);
    --wcs-com-nav-category-label-desktop-focus-outline-color: var(--wcs-semantic-color-border-focus-base);

    --wcs-com-nav-category-item-mobile-color: var(--wcs-semantic-color-text-primary);
    --wcs-com-nav-category-item-mobile-font-weight: var(--wcs-semantic-font-weight-roman);
    --wcs-com-nav-category-item-mobile-spacing-top: var(--wcs-semantic-spacing-large);
    --wcs-com-nav-category-item-mobile-spacing-left: calc(var(--wcs-semantic-spacing-base) * 3);
    --wcs-com-nav-category-item-mobile-gap: calc(var(--wcs-semantic-spacing-base) * 1.5);

    --wcs-com-nav-category-desktop-menu-background-color: transparent;
    --wcs-com-nav-category-desktop-menu-border-left-width: var(--wcs-semantic-border-width-default);
    --wcs-com-nav-category-desktop-menu-border-left-color: var(--wcs-semantic-color-border-secondary);
    --wcs-com-nav-category-desktop-menu-background-indicator-color: transparent;
    --wcs-com-nav-category-desktop-menu-gap: calc(var(--wcs-semantic-spacing-base) * 3);
    --wcs-com-nav-category-item-desktop-color: var(--wcs-semantic-color-text-primary);
    --wcs-com-nav-category-item-desktop-font-weight: var(--wcs-semantic-font-weight-roman);

    --wcs-com-nav-category-desktop-menu-padding-top: 50px;
    --wcs-com-nav-category-desktop-menu-padding-bottom: 50px;
    --wcs-com-nav-category-desktop-menu-padding-left: 50px;
    --wcs-com-nav-category-desktop-menu-padding-right: 0;

    display: block;
    height: fit-content;

    button {
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        font: inherit;
        color: inherit;
        cursor: initial;
    }

    .label-container {
        margin: 0;
        font-size: var(--wcs-com-nav-category-label-font-size);
        font-weight: var(--wcs-com-nav-category-label-mobile-font-weight);
        display: block;
        color: var(--wcs-com-nav-category-label-mobile-color);

        .arrow-container {
            display: none;
        }

        .arrow-icon {
            display: none;
        }
    }

    .item-container {
        display: flex;
        flex-direction: column;
        gap: var(--wcs-com-nav-category-item-mobile-gap);
        margin-left: var(--wcs-com-nav-category-item-mobile-spacing-left);
        margin-top: var(--wcs-com-nav-category-item-mobile-spacing-top);

        ::slotted(wcs-com-nav-item) {
            color: var(--wcs-com-nav-category-item-mobile-color);
            font-weight: var(--wcs-com-nav-category-item-mobile-font-weight);
        }
    }
}

@include for-tablet-portrait-up {
    :host {
        padding-bottom: unset;

        .item-container:not([data-open]) {
            display: none;
        }

        button {
            cursor: pointer;
        }

        .label-container {
            display: flex;
            align-items: center;
            gap: var(--wcs-com-nav-category-label-desktop-gap);

            font-weight: var(--wcs-com-nav-category-label-desktop-font-weight);
            cursor: pointer;
            user-select: none;
            padding-left: unset;
            color: var(--wcs-com-nav-category-label-desktop-color);

            .arrow-icon {
                display: inline-block;
                font-family: icons;
                font-size: 0.6rem;
                line-height: 1;
                box-sizing: border-box;
            }

            .arrow-container {
                display: unset;
            }
        }

        .label-container:focus-visible {
            @include focus-outline(var(--wcs-com-nav-category-label-desktop-focus-outline-color), 5px, 0.1rem);
        }

        @supports not selector(.label-container:focus-visible) {
            .label-container:focus-within {
                @include focus-outline(var(--wcs-com-nav-category-label-desktop-focus-outline-color), 5px, 0.1rem);
            }
        }

        button.label-container[aria-expanded="true"]:after {
            position: absolute;
            left: calc(calc(calc(100% / 2) + calc(var(--wcs-com-content-max-width) / 8)) - calc(1.125rem / 2));
            z-index: 2;
            display: block;
            width: 1.125rem;
            height: 1.125rem;
            content: "";
            background-color: var(--wcs-com-nav-category-desktop-menu-background-indicator-color);
            transform: rotate(45deg);
        }

        .item-container[data-open] {
            position: absolute;
            border-left: solid var(--wcs-com-nav-category-desktop-menu-border-left-width) var(--wcs-com-nav-category-desktop-menu-border-left-color);
            left: calc(calc(100% / 2) + calc(var(--wcs-com-content-max-width) / 8));
            top: 0;
            right: 0;
            padding: var(--wcs-com-nav-category-desktop-menu-padding-top) var(--wcs-com-nav-category-desktop-menu-padding-right) var(--wcs-com-nav-category-desktop-menu-padding-bottom) var(--wcs-com-nav-category-desktop-menu-padding-left);
            background-blend-mode: multiply;
            background-color: var(--wcs-com-nav-category-desktop-menu-background-color);
            box-sizing: border-box;
            height: calc(100%);

            margin-left: unset;
            margin-top: unset;

            display: flex;
            flex-direction: column;
            gap: var(--wcs-com-nav-category-desktop-menu-gap);
            align-items: start;

            ::slotted(wcs-com-nav-item) {
                color: var(--wcs-com-nav-category-item-desktop-color);
                font-weight: var(--wcs-com-nav-category-item-desktop-font-weight);
            }

            ::slotted(wcs-com-nav-item:focus-within) {
                @include com-nav-submenu-item-desktop-focus-outline(var(--wcs-com-nav-category-item-desktop-color));
            }
        }
    }
}
